var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector, useStorage } from 'master-hook';
import { STORAGE_NAME } from './constants';
export var translations = createSelector(function () { return useStorage(STORAGE_NAME).data; }, function (data) {
    var result = {};
    data.forEach(function (dataItem) {
        var _a, _b;
        var lang = result[dataItem.lang] || {};
        result = __assign(__assign({}, result), (_a = {}, _a[dataItem.lang] = __assign(__assign({}, lang), (_b = {}, _b[dataItem.key] = dataItem.translation, _b)), _a));
    });
});
